/* qtrat.net — تنسيق عرض السعر
   1) خانتان عشريتان بدل ثلاث: 9.000 -> 9.00 و 19.500 -> 19.50
      يُحذف الصفر الأخير فقط. أي سعر خانته الثالثة ليست صفراً (9.755) يُترك كما هو
      — فلا يُعرض أي رقم مخالف للسعر الحقيقي أبداً.
   2) JOD -> JD لاختصار رمز العملة.
   ملاحظة: صفحة الدفع تبقى بثلاث خانات لأنها من Shopify مباشرة ولا يمكن التدخل فيها.

   2026-09-24: السكربت بيتعرّف على المبلغ من صيغته، مش من العنصر اللي هو فيه.
   كل سعر بالموقع بيطلع بصيغة المتجر «{{amount}} JD» أو «{{amount}} JOD» — من Liquid ومن
   JavaScript الثيم ومن التطبيقات. قبل هيك كان يمشي على قائمة عناصر فيها اسمين مش موجودين
   (.hdt-free-shipping و.hdt-fs-bar)، فشريط التوصيل المجاني (hdt-free-shipping-bar) ضل يطلع
   «22.000 JOD» جنب «22.00 JD». هلأ أي عنصر جديد بيتغطى لحاله بلا ما حدا يضيفه لقائمة.
   الرقم اللي مش لاصق فيه JD أو JOD ما بينلمس، فمثلاً «1.000 ملغم» بعنوان منتج بيضل زي ما هو. */
(function () {
  var DEC = /(\d)\.(\d{2})0(?=\s?JO?D\b)/g;   // 22.000 JOD -> 22.00 JOD
  var CODE = /(\d\s?)JOD\b/g;                  // 22.00 JOD -> 22.00 JD
  var SKIP = /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA)$/;

  function fixText(node) {
    var v = node.nodeValue;
    if (!v || v.indexOf('D') < 0) return;
    var p = node.parentNode;
    if (p && SKIP.test(p.nodeName)) return;
    var out = v.replace(DEC, '$1.$2').replace(CODE, '$1JD');
    if (out !== v) node.nodeValue = out;
  }

  function fix(root) {
    if (!root) return;
    if (root.nodeType === 3) return fixText(root);
    if (root.nodeType !== 1 || SKIP.test(root.nodeName)) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false), n;
    while ((n = walker.nextNode())) fixText(n);
  }

  function start() {
    fix(document.body);
    try {
      // بيصحّح اللي انضاف أو تغيّر بس، وقبل ما المتصفح يرسم — فالصيغة القديمة ما بتبين ولا لحظة.
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var r = records[i];
          if (r.type === 'characterData') fixText(r.target);
          else for (var j = 0; j < r.addedNodes.length; j++) fix(r.addedNodes[j]);
        }
      }).observe(document.body, { childList: true, subtree: true, characterData: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
